import { render, staticRenderFns } from "./VsmFieldSelector.vue?vue&type=template&id=520a1788&scoped=true&"
import script from "./VsmFieldSelector.vue?vue&type=script&lang=js&"
export * from "./VsmFieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./VsmFieldSelector.vue?vue&type=style&index=0&id=520a1788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a1788",
  null
  
)

export default component.exports